import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import * as _ from "lodash";
import SettingsMenuTypes from "./views/Pages/Settings/SettingsMenuTypes";
import WABusinessMenuTypes from "./views/Pages/./WhatsappBusinessGupshup/detail/WABusinessMenuTypes";
import WABAMenuTypes from "./views/Pages/WhatsappBusiness/detail/WABAMenuTypes";
import WhatsappChannelMenuTypes from "./views/Pages/WhatsappV1/WhatsappChannelMenuTypes";
import WhatsappV2ChannelMenuTypes from "./views/Pages/WhatsappV2/WhatsappV2ChannelMenuTypes";
import PostaCellChannelMenuTypes from "./views/Pages/Integrations/SMS/PostaCell/detail/PostaCellChannelMenuTypes";
import MenuTypes from "./views/Pages/Mail/Detail/MenuTypes";
import TicimaxMenuTypes from "./views/Pages/Integrations/Ticimax/detail/TicimaxMenuTypes";
import IGMenuTypes from "./views/Pages/Integrations/instagram/detail/IGMenuTypes";
import IGV2MenuTypes from "./views/Pages/Integrations/instagram-v2/detail/IGV2MenuTypes";
import MessengerMenuTypes from "./views/Pages/Integrations/messenger/detail/MessengerMenuTypes";
import ChatbotMenuItems from "./views/Pages/Chatbot/ChatbotMenuItems";
import TeamGramMenuTypes from "./views/Pages/Integrations/TeamGram/detail/TeamGramMenuTypes";
import MetaLeadsMenuTypes from "./views/Pages/Integrations/meta-leads/detail/MetaLeadsMenuTypes";
import YouTubeMenuTypes from "./views/Pages/Integrations/youtube-comments/detail/YouTubeMenuTypes";
import GoogleBusinessMenuTypes from "./views/Pages/Integrations/google-business-reviews/detail/GoogleBusinessMenuTypes";
import GooglePlayMenuTypes from "./views/Pages/Integrations/google-play-reviews/detail/GooglePlayMenuTypes";
import AppStoreMenuTypes from "./views/Pages/Integrations/appstore-reviews/detail/AppStoreMenuTypes";
import AutomationMenuItems from "./views/Pages/Automation/AutomationMenuItems";
import CalendarEvents from "./views/Pages/Calendar/Component/calendar-events/CalendarEvents.vue";
import ReservationPrograms from "./views/Pages/Calendar/Component/ReservationPrograms.vue";
import TrendyolMenuTypes from "./views/Pages/Integrations/Trendyol/detail/TrendyolMenuTypes";
import ZohoMenuTypes from "./views/Pages/Integrations/zoho/ZohoMenuTypes";
import SYSTEM_PUBSUB from "./utils/systemPubSub";
import WebChatMenuTypes from "./views/Pages/Integrations/WebChat/components/WebChatMenuTypes";
import LinkedinMenuTypes from "./views/Pages/Integrations/linkedin/LinkedinMenuTypes";
import TelegramMenuTypes from "./views/Pages/Integrations/telegram/TelegramMenuTypes";
import VoiceAgentMenuTypes from "./views/Pages/Integrations/voice-agent/VoiceAgentMenuTypes";
import TelnyxMenuTypes from "./views/Pages/Integrations/Telnyx/detail/TelnyxMenuTypes";
import NetGsmMenuTypes from "./views/Pages/Integrations/NetGSM/detail/NetGsmMenuTypes";

if (store.getters["auth/isLoggedIn"]) {
    store.dispatch("permission/getPermissions");
}

Vue.use(Router);

const router = new Router({
    mode: "history",
    scrollBehavior: () => ({
        y: 0,
    }),
    routes: [
        {
            path: "/login",
            name: "login",
            component: () => import("./views/Pages/Login"),
            meta: {
                suspendAllow: true,
            },
        },
        {
            path: "/forgot-password",
            name: "forgot-password",
            component: () => import("./views/Pages/ForgotPassword"),
            meta: {
                suspendAllow: true,
            },
        },
        {
            path: "/passwordless-login",
            name: "passwordless-login",
            component: () => import("./views/Pages/PasswordlessLogin"),
            meta: {
                suspendAllow: true,
            },
        },
        {
            path: "/reset-password",
            name: "reset-password",
            component: () => import("./views/Pages/ResetPassword"),
            meta: {
                suspendAllow: true,
            },
        },
        {
            path: "/",
            meta: { requiresAuth: true },
            component: () => import("./layouts/Panel"),
            children: [
                {
                    path: "/blocked",
                    name: "blocked",
                    component: () => import("./views/Pages/BlockedIP.vue"),
                    meta: {
                        title: "Blocked",
                    },
                },
                {
                    path: "/plans",
                    name: "Plans",
                    component: () => import("./views/Pages/Plans/Plans.vue"),
                    meta: {
                        title: "Plan Managements",
                    },
                },
                {
                    path: "/",
                    name: "home",
                    redirect: (to) => {
                        if (store.state.auth.adminUser != null) {
                            return "cluster-dashboard";
                        } else {
                            return "chat";
                        }
                    },
                },
                {
                    path: "denied",
                    name: "permission",
                    component: () => import("./views/Pages/PermissionDenided"),
                    meta: {
                        title: "İzin Yok!",
                    },
                },
                {
                    path: "chat",
                    name: "chat",
                    component: () => import("./views/Pages/Chat/Chat.vue"),
                    meta: {
                        title: "Chat",
                        permission: "chat.get",
                    },
                },
                {
                    path: "/integrations/sms/postacell",
                    name: "sms-postacell",
                    component: () => import("./views/Pages/Integrations/SMS/PostaCell/PostaCellChannels.vue"),
                    meta: {
                        title: "PostaCELL Channels",
                    },
                },
                {
                    path: "/integrations/sms/postacell/:id/detail",
                    name: "sms-postacell-detail",
                    component: () =>
                        import("./views/Pages/Integrations/SMS/PostaCell/detail/PostaCellChannelDetail.vue"),
                    meta: {
                        title: "PostaCELL Channel Detail",
                    },
                },
                ...Object.values(PostaCellChannelMenuTypes).map(({ id, group, path, label }) => ({
                    path: `/integrations/sms/postacell/:id/detail/${path}`,
                    name: `sms-postacell-detail-${id}`,
                    component: () =>
                        import("./views/Pages/Integrations/SMS/PostaCell/detail/PostaCellChannelDetail.vue"),
                    meta: {
                        title: "PostaCELL Channel Detail",
                    },
                })),
                {
                    path: "/integrations/openai",
                    name: "openai",
                    component: () => import("./views/Pages/Integrations/OpenAI/OpenAIChannels.vue"),
                    meta: {
                        title: "OpenAI Channels",
                    },
                },
                {
                    path: "/integrations/voice-agent",
                    name: "voice-agent",
                    component: () => import("./views/Pages/Integrations/voice-agent/VoiceAgentChannels.vue"),
                    meta: {
                        title: "AI Voice Agent",
                        permission: ["voice-agent.get"],
                    },
                },
                {
                    path: "/integrations/ideasoft",
                    name: "ideasoft",
                    component: () => import("./views/Pages/Integrations/Ideasoft/IdeasoftChannels.vue"),
                    meta: {
                        title: "Ideasoft Channels",
                    },
                },
                {
                    path: "/integrations/bitrix24",
                    name: "bitrix24",
                    component: () => import("./views/Pages/Integrations/bitrix/BitrixChannels.vue"),
                    meta: {
                        title: "Bitrix24 Channels",
                    },
                },

                {
                    path: "/integrations/meta-leads",
                    name: "leads",
                    component: () => import("./views/Pages/Integrations/meta-leads/MetaLeadsChannels.vue"),
                    meta: {
                        title: "Meta Leads",
                    },
                },
                ...Object.values(ZohoMenuTypes).map(({ id, group, path, label }) => ({
                    path: `/integrations/zoho/:id/detail/${path}`,
                    name: `zoho-detail-${id}`,
                    component: () => import("./views/Pages/Integrations/zoho/ZohoChannelDetail.vue"),
                    meta: {
                        title: "Zoho Channel Detail",
                    },
                })),
                {
                    path: "/integrations/zoho/:id/detail",
                    name: "zoho-detail",
                    component: () => import("./views/Pages/Integrations/zoho/ZohoChannelDetail.vue"),
                    meta: {
                        title: "Zoho Channel Detail",
                    },
                },
                {
                    path: "/integrations/zoho",
                    name: "zoho",
                    component: () => import("./views/Pages/Integrations/zoho/ZohoChannels.vue"),
                    meta: {
                        title: "Zoho CRM Channels",
                    },
                },

                ...Object.values(TicimaxMenuTypes).map(({ id, group, path, label }) => ({
                    path: `/integrations/ticimax/:id/detail/${path}`,
                    name: `ticimax-detail-${id}`,
                    component: () => import("./views/Pages/Integrations/Ticimax/detail/TicimaxChannelDashboard.vue"),
                    meta: {
                        title: "Ticimax Channel Detail",
                    },
                })),

                {
                    path: "/integrations/ticimax/:id/detail",
                    name: "ticimax-detail",
                    component: () => import("./views/Pages/Integrations/Ticimax/detail/TicimaxChannelDashboard.vue"),
                    meta: {
                        title: "Ticimax Channel Detail",
                    },
                },
                {
                    path: "/integrations/ticimax",
                    name: "ticimax",
                    component: () => import("./views/Pages/Integrations/Ticimax/TicimaxChannels.vue"),
                    meta: {
                        title: "Ticimax Channels",
                    },
                },
                ...Object.values(TeamGramMenuTypes).map(({ id, group, path, label }) => ({
                    path: `/integrations/teamgram/:id/detail/${path}`,
                    name: `teamgram-detail-${id}`,
                    component: () => import("./views/Pages/Integrations/TeamGram/detail/TeamGramChannelDashboard.vue"),
                    meta: {
                        title: "TeamGram Channel Detail",
                    },
                })),
                {
                    path: "/integrations/ticimax-v2",
                    name: "ticimax-v2",
                    component: () => import("./views/Pages/Integrations/Ticimax-V2/TicimaxChannelsV2.vue"),
                    meta: {
                        title: "Ticimax V2 Channels",
                    },
                },
                {
                    path: "/integrations/teamgram/:id/detail",
                    name: "teamgram-detail",
                    component: () => import("./views/Pages/Integrations/TeamGram/detail/TeamGramChannelDashboard.vue"),
                    meta: {
                        title: "TeamGram Channel Detail",
                    },
                },
                {
                    path: "/integrations/teamgram",
                    name: "Teamgram",
                    component: () => import("./views/Pages/Integrations/TeamGram/TeamGramChannels.vue"),
                    meta: {
                        title: "TeamGram Channels",
                    },
                },
                ...Object.values(TeamGramMenuTypes).map(({ id, group, path, label }) => ({
                    path: `/integrations/holidayplus/:id/detail/${path}`,
                    name: `holidayplus-detail-${id}`,
                    component: () =>
                        import("./views/Pages/Integrations/HolidayPlus/detail/HolidayPlusChannelDashboard.vue"),
                    meta: {
                        title: "Holiday+ Channel Detail",
                    },
                })),
                {
                    path: "/integrations/holidayplus/:id/detail",
                    name: "holidayplus-detail",
                    component: () =>
                        import("./views/Pages/Integrations/HolidayPlus/detail/HolidayPlusChannelDashboard.vue"),
                    meta: {
                        title: "Holiday+ Channel Detail",
                    },
                },
                {
                    path: "/integrations/holidayplus",
                    name: "holidayplus",
                    component: () => import("./views/Pages/Integrations/HolidayPlus/HolidayPlusChannels.vue"),
                    meta: {
                        title: "Holiday+ Channels",
                    },
                },
                {
                    path: "/integrations/linkedin",
                    name: "linkedin",
                    component: () => import("./views/Pages/Integrations/linkedin/LinkedinChannels.vue"),
                    meta: {
                        title: "Linkedin Channels",
                        shouldSelectAllow: true,
                    },
                },
                ...Object.values(LinkedinMenuTypes.Items()).map(({ key, group, path, label }) => ({
                    path: `/integrations/linkedin/:id/detail/${key}`,
                    name: `linkedin-detail-${key}`,
                    component: () => import("./views/Pages/Integrations/linkedin/LinkedinChannelDetail.vue"),
                    meta: {
                        title: "Linkedin Detail",
                    },
                })),
                {
                    path: "/integrations/linkedin/:id/detail",
                    name: "linkedin-detail",
                    component: () => import("./views/Pages/Integrations/linkedin/LinkedinChannelDetail.vue"),
                    meta: {
                        title: "Linkedin Detail",
                    },
                },

                {
                    path: "/integrations/telegram-qr",
                    name: "telegram",
                    component: () => import("./views/Pages/Integrations/telegram/TelegramChannels.vue"),
                    meta: {
                        title: "Telegram Channels",
                        shouldSelectAllow: true,
                    },
                },
                ...Object.values(TelegramMenuTypes.Items()).map(({ key, group, path, label }) => ({
                    path: `/integrations/telegram-qr/:id/detail/${key}`,
                    name: `telegram-detail-${key}`,
                    component: () => import("./views/Pages/Integrations/telegram/TelegramChannelDetail.vue"),
                    meta: {
                        title: "Telegram Detail",
                    },
                })),
                {
                    path: "/integrations/telegram-qr/:id/detail",
                    name: "telegram-detail",
                    component: () => import("./views/Pages/Integrations/telegram/TelegramChannelDetail.vue"),
                    meta: {
                        title: "Telegram Detail",
                    },
                },

                {
                    path: "/integrations/whatsapp-v3",
                    name: "whatsapp-v3",
                    component: () => import("./views/Pages/Integrations/whatsapp-v3/W3Channels.vue"),
                    meta: {
                        title: "Whatsapp V3 Channels",
                        shouldSelectAllow: true,
                    },
                },
                ...Object.values(TelegramMenuTypes.Items()).map(({ key, group, path, label }) => ({
                    path: `/integrations/whatsapp-v3/:id/detail/${key}`,
                    name: `whatsapp-v3-detail-${key}`,
                    component: () => import("./views/Pages/Integrations/whatsapp-v3/W3ChannelDetail.vue"),
                    meta: {
                        title: "Whatsapp V3 Detail",
                    },
                })),
                {
                    path: "/integrations/whatsapp-v3/:id/detail/comparison",
                    name: "whatsapp-v3-detail-comparison",
                    component: () => import("./views/Pages/Integrations/whatsapp-v3/W3ChannelDetail.vue"),
                    meta: {
                        title: "WhatsApp Çözümleri Karşılaştırması",
                    },
                },
                {
                    path: "/integrations/whatsapp-v3/:id/detail",
                    name: "whatsapp-v3-detail",
                    component: () => import("./views/Pages/Integrations/whatsapp-v3/W3ChannelDetail.vue"),
                    meta: {
                        title: "Whatsapp V3 Detail",
                    },
                },
                ...Object.values(WABusinessMenuTypes.Items()).map(({ key, group, path, label }) => ({
                    path: `/integrations/whatsapp-business-api/:id/detail/${key}`,
                    name: `whatsapp-business-api-detail-${key}`,
                    component: () =>
                        import("./views/Pages/WhatsappBusinessGupshup/detail/WhatsappBusinessChannelDetail.vue"),
                    meta: {
                        title: "Whatsapp Business API Channel Detail",
                    },
                })),
                {
                    path: "/integrations/whatsapp-business-api/:id/detail/comparison",
                    name: "whatsapp-business-api-detail-comparison",
                    component: () =>
                        import("./views/Pages/WhatsappBusinessGupshup/detail/WhatsappBusinessChannelDetail.vue"),
                    meta: {
                        title: "WhatsApp Çözümleri Karşılaştırması",
                    },
                },

                {
                    path: "/integrations/whatsapp-business-api/:id/detail",
                    name: "whatsapp-business-api-detail",
                    component: () =>
                        import("./views/Pages/./WhatsappBusinessGupshup/detail/WhatsappBusinessChannelDetail.vue"),
                    meta: {
                        title: "Whatsapp Business API Channel Detail",
                    },
                },
                {
                    path: "/integrations/whatsapp-business-api",
                    name: "whatsapp-business-api",
                    component: () => import("./views/Pages/WhatsappBusinessGupshup/GupshupChannels.vue"),
                    meta: {
                        title: "Whatsapp Business API Channels",
                        shouldSelectAllow: true,
                    },
                },
                {
                    path: "/integrations/waba",
                    name: "waba",
                    component: () => import("./views/Pages/WhatsappBusiness/WABAChannels.vue"),
                    meta: {
                        title: "Whatsapp Business API Channels",
                        shouldSelectAllow: true,
                    },
                },
                ...Object.values(WABAMenuTypes.Items()).map(({ key }) => ({
                    path: `/integrations/waba/:id/detail/${key}`,
                    name: `waba-detail-${key}`,
                    component: () => import("./views/Pages/WhatsappBusiness/detail/WABAChannelDetail.vue"),
                    meta: {
                        title: "WABA Channel Detail",
                    },
                })),
                {
                    path: "/integrations/waba/:id/detail/comparison",
                    name: "waba-detail-comparison",
                    component: () => import("./views/Pages/WhatsappBusiness/detail/WABAChannelDetail.vue"),
                    meta: {
                        title: "WhatsApp Çözümleri Karşılaştırması",
                    },
                },
                {
                    path: "/integrations/waba/:id/detail",
                    name: "waba-detail",
                    component: () => import("./views/Pages/WhatsappBusiness/detail/WABAChannelDetail.vue"),
                    meta: {
                        title: "WABA Channel Detail",
                    },
                },
                ...Object.values(WhatsappChannelMenuTypes).map(({ id, group, path, label }) => ({
                    path: `/integrations/whatsapp-v1/:id/detail/${path}`,
                    name: `whatsapp-v1-detail-${id}`,
                    component: () => import("./views/Pages/WhatsappV1/MultiWhatsappChannelDetail.vue"),
                    meta: {
                        title: "Whatsapp Business API Channel Detail",
                    },
                })),
                {
                    path: "/integrations/whatsapp-v1/:id/detail",
                    name: "whatsapp-v1-detail",
                    component: () => import("./views/Pages/WhatsappV1/MultiWhatsappChannelDetail.vue"),
                    meta: {
                        title: "Whatsapp Business API Channel Detail",
                    },
                },
                {
                    path: "/integrations/whatsapp-v1/:id/update",
                    name: "whatsapp-channel-detail",
                    component: () => import("./views/Pages/WhatsappV1/MultiWhatsappChannelDetail.vue"),
                    meta: {
                        title: "Whatsapp Channel Detail",
                    },
                },
                {
                    path: "/integrations/whatsapp-v1",
                    name: "whatsapp-v1",
                    component: () => import("./views/Pages/WhatsappV1/MultiWhatsappChannels.vue"),
                    meta: {
                        title: "Multi Whatsapp Channels",
                        shouldSelectAllow: true,
                    },
                },

                ...Object.values(WhatsappV2ChannelMenuTypes).map(({ id, group, path, label }) => ({
                    path: `/integrations/whatsapp-v2/:id/detail/${path}`,
                    name: `whatsapp-v2-detail-${id}`,
                    component: () => import("./views/Pages/WhatsappV2/W2ChannelDetail.vue"),
                    meta: {
                        title: "Whatsapp V2 Channel Detail",
                    },
                })),
                {
                    path: "/integrations/whatsapp-v2/:id/detail/comparison",
                    name: "whatsapp-v2-detail-comparison",
                    component: () => import("./views/Pages/WhatsappV2/W2ChannelDetail.vue"),
                    meta: {
                        title: "WhatsApp Çözümleri Karşılaştırması",
                    },
                },
                {
                    path: "/integrations/whatsapp-v2/:id/detail",
                    name: "whatsapp-v2-detail",
                    component: () => import("./views/Pages/WhatsappV2/W2ChannelDetail.vue"),
                    meta: {
                        title: "Whatsapp V2 Channel Detail",
                    },
                },
                {
                    path: "/integrations/whatsapp-v2/:id/update",
                    name: "whatsapp-v2-detail",
                    component: () => import("./views/Pages/WhatsappV2/W2ChannelDetail.vue"),
                    meta: {
                        title: "Whatsapp V2 Channel Detail",
                    },
                },
                {
                    path: "/integrations/whatsapp-v2",
                    name: "whatsapp-v2",
                    component: () => import("./views/Pages/WhatsappV2/W2Channels.vue"),
                    meta: {
                        title: "Whatsapp V2 Channels",
                        shouldSelectAllow: true,
                    },
                },
                ...Object.values(MetaLeadsMenuTypes).map(({ id, group, path, label }) => ({
                    path: `/integrations/meta-leads/:id/detail/${path}`,
                    name: `meta-leads-detail-${id}`,
                    component: () => import("./views/Pages/Integrations/meta-leads/detail/MetaLeadsChannelDetail.vue"),
                    meta: {
                        title: "Meta Leads Channel Detail",
                    },
                })),
                {
                    path: "/integrations/meta-leads",
                    name: "leads",
                    component: () => import("./views/Pages/Integrations/meta-leads/MetaLeadsChannels.vue"),
                    meta: {
                        title: "Meta Leads",
                    },
                },
                {
                    path: `/integrations/meta-leads/:id/detail`,
                    name: `meta-leads-detail-detail`,
                    component: () => import("./views/Pages/Integrations/meta-leads/detail/MetaLeadsChannelDetail.vue"),
                    meta: {
                        title: "Meta Leads Channel Detail",
                    },
                },
                {
                    path: "/integrations/youtube-comments",
                    name: "youtube-comments",
                    component: () => import("./views/Pages/Integrations/youtube-comments/YouTubeChannels.vue"),
                    meta: {
                        title: "YouTube Comments",
                    },
                },
                ...Object.values(YouTubeMenuTypes.Items()).map(({ key }) => ({
                    path: `/integrations/youtube-comments/:id/detail/${key}`,
                    name: `youtube-comments-detail-${key}`,
                    component: () => import("./views/Pages/Integrations/youtube-comments/detail/YouTubeChannelDetail.vue"),
                    meta: {
                        title: "YouTube Comments Channel Detail",
                    },
                })),
                {
                    path: `/integrations/youtube-comments/:id/detail`,
                    name: `youtube-comments-detail`,
                    component: () => import("./views/Pages/Integrations/youtube-comments/detail/YouTubeChannelDetail.vue"),
                    meta: {
                        title: "YouTube Comments Channel Detail",
                    },
                },
                {
                    path: `/integrations/youtube-comments/:id/video/:videoId`,
                    name: `youtube-video-detail`,
                    component: () => import("./views/Pages/Integrations/youtube-comments/detail/VideoDetailPage.vue"),
                    meta: {
                        title: "YouTube Video Detail",
                    },
                },
                {
                    path: "/integrations/google-business-reviews",
                    name: "google-business-reviews",
                    component: () => import("./views/Pages/Integrations/google-business-reviews/GoogleBusinessChannels.vue"),
                    meta: {
                        title: "Google Business Reviews",
                    },
                },
                ...Object.values(GoogleBusinessMenuTypes.Items()).map(({ key }) => ({
                    path: `/integrations/google-business-reviews/:id/detail/${key}`,
                    name: `google-business-reviews-detail-${key}`,
                    component: () => import("./views/Pages/Integrations/google-business-reviews/detail/GoogleBusinessChannelDetail.vue"),
                    meta: {
                        title: "Google Business Reviews Channel Detail",
                    },
                })),
                {
                    path: `/integrations/google-business-reviews/:id/detail`,
                    name: `google-business-reviews-detail`,
                    component: () => import("./views/Pages/Integrations/google-business-reviews/detail/GoogleBusinessChannelDetail.vue"),
                    meta: {
                        title: "Google Business Reviews Channel Detail",
                    },
                },
                {
                    path: "/integrations/google-play-reviews",
                    name: "google-play-reviews",
                    component: () => import("./views/Pages/Integrations/google-play-reviews/GooglePlayChannels.vue"),
                    meta: {
                        title: "Google Play Reviews",
                    },
                },
                ...Object.values(GooglePlayMenuTypes.Items()).map(({ key }) => ({
                    path: `/integrations/google-play-reviews/:id/detail/${key}`,
                    name: `google-play-reviews-detail-${key}`,
                    component: () => import("./views/Pages/Integrations/google-play-reviews/detail/GooglePlayChannelDetail.vue"),
                    meta: {
                        title: "Google Play Reviews Channel Detail",
                    },
                })),
                {
                    path: `/integrations/google-play-reviews/:id/detail`,
                    name: `google-play-reviews-detail`,
                    component: () => import("./views/Pages/Integrations/google-play-reviews/detail/GooglePlayChannelDetail.vue"),
                    meta: {
                        title: "Google Play Reviews Channel Detail",
                    },
                },
                {
                    path: "/integrations/appstore-reviews",
                    name: "appstore-reviews",
                    component: () => import("./views/Pages/Integrations/appstore-reviews/AppStoreChannels.vue"),
                    meta: {
                        title: "App Store Reviews",
                    },
                },
                ...Object.values(AppStoreMenuTypes.Items()).map(({ key }) => ({
                    path: `/integrations/appstore-reviews/:id/detail/${key}`,
                    name: `appstore-reviews-detail-${key}`,
                    component: () => import("./views/Pages/Integrations/appstore-reviews/detail/AppStoreChannelDetail.vue"),
                    meta: {
                        title: "App Store Reviews Channel Detail",
                    },
                })),
                {
                    path: `/integrations/appstore-reviews/:id/detail`,
                    name: `appstore-reviews-detail`,
                    component: () => import("./views/Pages/Integrations/appstore-reviews/detail/AppStoreChannelDetail.vue"),
                    meta: {
                        title: "App Store Reviews Channel Detail",
                    },
                },

                ...Object.values(IGMenuTypes).map(({ id, group, path, label }) => ({
                    path: `/integrations/instagram/:id/detail/${path}`,
                    name: `instagram-detail-${id}`,
                    component: () => import("./views/Pages/Integrations/instagram/detail/IGChannelDetail.vue"),
                    meta: {
                        title: "Instagram Channel Detail",
                    },
                })),
                {
                    path: `/integrations/instagram/:id/detail`,
                    name: `instagram-detail-detail`,
                    component: () => import("./views/Pages/Integrations/instagram/detail/IGChannelDetail.vue"),
                    meta: {
                        title: "Instagram Channel Detail",
                    },
                },
                {
                    path: "/integrations/instagram",
                    name: "instagram",
                    component: () => import("./views/Pages/Integrations/instagram/InstagramChannels.vue"),
                    meta: {
                        title: "Instagram",
                        shouldSelectAllow: true,
                    },
                },
                {
                    path: "/integrations/instagram/users",
                    name: "instagram-users",
                    component: () => import("./views/Pages/Integrations/instagram-basic/pages/users/InstagramUserList"),
                    meta: {
                        title: "Instagram Contact List",
                        permission: "integrations.instagram.view",
                    },
                },

                ...Object.values(IGV2MenuTypes).map(({ id, group, path, label }) => ({
                    path: `/integrations/instagram-v2/:id/detail/${path}`,
                    name: `instagram-v2-detail-${id}`,
                    component: () => import("./views/Pages/Integrations/instagram-v2/detail/IGV2ChannelDetail.vue"),
                    meta: {
                        title: "Instagram V2 Channel Detail",
                    },
                })),
                {
                    path: `/integrations/instagram-v2/:id/detail`,
                    name: `instagram-v2-detail-detail`,
                    component: () => import("./views/Pages/Integrations/instagram-v2/detail/IGV2ChannelDetail.vue"),
                    meta: {
                        title: "Instagram V2 Channel Detail",
                    },
                },
                {
                    path: "/integrations/instagram-v2",
                    name: "instagram-v2",
                    component: () => import("./views/Pages/Integrations/instagram-v2/InstagramV2Channels.vue"),
                    meta: {
                        title: "Instagram V2",
                        shouldSelectAllow: true,
                    },
                },

                ...Object.values(MessengerMenuTypes).map(({ id, group, path, label }) => ({
                    path: `/integrations/messenger/:id/detail/${path}`,
                    name: `messenger-detail-${id}`,
                    component: () => import("./views/Pages/Integrations/messenger/detail/MessengerChannelDetail.vue"),
                    meta: {
                        title: "Messenger Channel Detail",
                    },
                })),

                {
                    path: `/integrations/messenger/:id/detail`,
                    name: `messenger-detail-detail`,
                    component: () => import("./views/Pages/Integrations/messenger/detail/MessengerChannelDetail.vue"),
                    meta: {
                        title: "Messenger Channel Detail",
                    },
                },
                {
                    path: "/integrations/messenger",
                    name: "messenger",
                    component: () => import("./views/Pages/Integrations/messenger/MessengerChannels.vue"),
                    meta: {
                        title: "Messenger",
                        shouldSelectAllow: true,
                    },
                },
                {
                    path: "/integrations/webchat",
                    name: "webchat",
                    component: () => import("./views/Pages/Integrations/WebChat/WebChat.vue"),
                    meta: {
                        title: "WebChat",
                    },
                },
                ...Object.values(WebChatMenuTypes()).map(({ key, label, meta = {} }) => ({
                    path: `/integrations/webchat/${key}`,
                    name: `integrations-webchat-${key}`,
                    component: () => import("./views/Pages/Integrations/WebChat/WebChat.vue"),
                    meta: {
                        title: `WebChat - ${label}`,
                        ...meta,
                    },
                })),

                ...Object.values(TrendyolMenuTypes).map(({ id, group, path, label }) => ({
                    path: `/integrations/trendyol/:id/detail/${path}`,
                    name: `trendyol-detail-${id}`,
                    component: () => import("./views/Pages/Integrations/Trendyol/detail/TrendyolChannelDetail.vue"),
                    meta: {
                        title: "Trendyol Channel Detail",
                    },
                })),
                {
                    path: "/integrations/trendyol/:id/detail",
                    name: "trendyol-detail",
                    component: () => import("./views/Pages/Integrations/Trendyol/detail/TrendyolChannelDetail.vue"),
                    meta: {
                        title: "Trendyol Channel Detail",
                    },
                },
                {
                    path: "/integrations/trendyol",
                    name: "trendyol",
                    component: () => import("./views/Pages/Integrations/Trendyol/TrendyolChannels.vue"),
                    meta: {
                        title: "Trendyol",
                    },
                },
                {
                    path: "/integrations/t-soft",
                    name: "t-soft",
                    component: () => import("./views/Pages/Integrations/t-soft/TsoftChannels.vue"),
                    meta: {
                        title: "T-Soft Channels",
                    },
                },
                {
                    path: "integrations/ikas",
                    name: "ikas",
                    component: () => import("./views/Pages/Integrations/Ikas/IkasChannels.vue"),
                    meta: {
                        title: "IKAS Channels",
                    },
                },
                {
                    path: "/integrations/webphone/redsantral",
                    name: "webphone-redsantral",
                    component: () => import("./views/Pages/Integrations/KirmiziSantral/KirmiziSantralChannels.vue"),
                    meta: {
                        title: "Webphone Channels",
                    },
                },
                {
                    path: "/integrations/webphone/redsantral/:id/detail",
                    name: "webphone-redsantral-detail",
                    component: () =>
                        import("./views/Pages/Integrations/KirmiziSantral/detail/KirmiziSantralChannelDetail.vue"),
                    meta: {
                        title: "Webphone Channel Detail",
                    },
                },
                {
                    path: "/integrations/webphone/redsantral/:id/detail/extensions",
                    name: "webphone-redsantral-detail-extensions",
                    component: () =>
                        import("./views/Pages/Integrations/KirmiziSantral/detail/KirmiziSantralChannelDetail.vue"),
                    meta: {
                        title: "Webphone Extensions",
                    },
                },
                {
                    path: "/integrations/webphone/redsantral/:id/detail/extension-mapping",
                    name: "webphone-redsantral-detail-extension-mapping",
                    component: () =>
                        import("./views/Pages/Integrations/KirmiziSantral/detail/KirmiziSantralChannelDetail.vue"),
                    meta: {
                        title: "Webphone Extension Mapping",
                    },
                },
                {
                    path: "/integrations/webphone/redsantral/:id/detail/webhooks",
                    name: "webphone-redsantral-detail-webhooks",
                    component: () =>
                        import("./views/Pages/Integrations/KirmiziSantral/detail/KirmiziSantralChannelDetail.vue"),
                    meta: {
                        title: "Webphone Webhooks",
                    },
                },
                {
                    path: "/integrations/webphone/redsantral/:id/detail/cdr",
                    name: "webphone-redsantral-detail-cdr",
                    component: () =>
                        import("./views/Pages/Integrations/KirmiziSantral/detail/KirmiziSantralChannelDetail.vue"),
                    meta: {
                        title: "Webphone CDR",
                    },
                },
                {
                    path: "/integrations/webphone/redsantral/:id/detail/automations",
                    name: "webphone-redsantral-detail-automations",
                    component: () =>
                        import("./views/Pages/Integrations/KirmiziSantral/detail/KirmiziSantralChannelDetail.vue"),
                    meta: {
                        title: "Webphone Otomasyonlar",
                    },
                },
                {
                    path: "/integrations/webphone/telnyx",
                    name: "webphone-telnyx",
                    component: () => import("./views/Pages/Integrations/Telnyx/TelnyxChannels.vue"),
                    meta: {
                        title: "Telnyx Channels",
                    },
                },
                {
                    path: "/integrations/webphone/telnyx/:id/detail",
                    name: "webphone-telnyx-detail",
                    component: () => import("./views/Pages/Integrations/Telnyx/detail/TelnyxChannelDetail.vue"),
                    meta: {
                        title: "Telnyx Channel Detail",
                    },
                },
                ...TelnyxMenuTypes.Items().map(({ key, label }) => ({
                    path: `/integrations/webphone/telnyx/:id/detail/${key}`,
                    name: `webphone-telnyx-detail-${key}`,
                    component: () => import("./views/Pages/Integrations/Telnyx/detail/TelnyxChannelDetail.vue"),
                    meta: {
                        title: `Telnyx ${label}`,
                    },
                })),
                {
                    path: "/integrations/webphone/telnyx/:id/detail/automations",
                    name: "webphone-telnyx-detail-automations",
                    component: () => import("./views/Pages/Integrations/Telnyx/detail/TelnyxChannelDetail.vue"),
                    meta: {
                        title: "Telnyx Otomasyonlar",
                    },
                },
                {
                    path: "/integrations/webphone/netgsm",
                    name: "webphone-netgsm",
                    component: () => import("./views/Pages/Integrations/NetGSM/NetGsmChannels.vue"),
                    meta: {
                        title: "NetGSM Channels",
                    },
                },
                {
                    path: "/integrations/webphone/netgsm/:id/detail",
                    name: "webphone-netgsm-detail",
                    component: () => import("./views/Pages/Integrations/NetGSM/detail/NetGsmChannelDetail.vue"),
                    meta: {
                        title: "NetGSM Channel Detail",
                    },
                },
                ...Object.values(NetGsmMenuTypes.MENU_TYPES).map((key) => ({
                    path: `/integrations/webphone/netgsm/:id/detail/${key}`,
                    name: `webphone-netgsm-detail-${key}`,
                    component: () => import("./views/Pages/Integrations/NetGSM/detail/NetGsmChannelDetail.vue"),
                    meta: {
                        title: `NetGSM ${key}`,
                    },
                })),
                {
                    path: "/integrations/webphone/netgsm/:id/detail/automations",
                    name: "webphone-netgsm-detail-automations",
                    component: () => import("./views/Pages/Integrations/NetGSM/detail/NetGsmChannelDetail.vue"),
                    meta: {
                        title: "NetGSM Otomasyonlar",
                    },
                },
                {
                    path: "/integrations/mail",
                    name: "integrations-mail",
                    component: () => import("./views/Pages/Mail/MailIntegration"),
                    meta: {
                        title: "Mail",
                    },
                },
                {
                    path: "/integrations/mail/:id/:type/detail",
                    name: "integrations-mail",
                    component: () => import("./views/Pages/Mail/MailIntegrationDetail"),
                    meta: {
                        title: "Mail",
                    },
                },
                ...Object.values(MenuTypes).map(({ id, group, path, label }) => ({
                    path: `/integrations/mail/:id/:type/detail/${path}`,
                    name: `mail_integration_detail${id}`,
                    component: () => import("./views/Pages/Mail/MailIntegrationDetail.vue"),
                    meta: {
                        title: "Mail",
                    },
                })),
                {
                    path: "/integrations/whatsapp",
                    name: "whatsapp",
                    component: () => import("./views/Pages/Whatsapp/pages/integration/WhatsappIntegration"),
                    meta: {
                        title: "Whatsapp",
                        permission: "integrations.whatsapp.view",
                    },
                },
                {
                    path: "/integrations/whatsapp/contact-list",
                    name: "whatsapp-contact-list",
                    component: () => import("./views/Pages/Whatsapp/pages/contact-list/ContactListV2"),
                    meta: {
                        title: "Whatsapp Contact List",
                        permission: "integrations.whatsapp.view",
                    },
                },
                {
                    path: "/integrations/whatsapp/broadcast/customer-groups",
                    name: "whatsapp-broadcast-customer-groups",
                    component: () => import("./views/Pages/Whatsapp/pages/broadcast/CustomerGroups"),
                    meta: {
                        title: "Whatsapp Broadcast Customer Groups",
                        permission: "integrations.whatsapp.view",
                    },
                },
                {
                    path: "/integrations/whatsapp/broadcast/message-templates",
                    name: "whatsapp-broadcast-message-templates",
                    component: () => import("./views/Pages/Whatsapp/pages/broadcast/MessageTemplates"),
                    meta: {
                        title: "Whatsapp Broadcast Message Templates",
                        permission: "integrations.whatsapp.view",
                    },
                },
                {
                    path: "/module/:moduleName/settings",
                    name: "module-settings",
                    component: () => import("./views/Pages/Module/ModuleSettings.vue"),
                    meta: {
                        title: "Module Settings",
                    },
                },
                {
                    path: "/module/:moduleName/record/:recordId",
                    name: "module-record-viewer",
                    component: () => import("./views/Pages/Module/ModuleRecordViewer.vue"),
                    meta: {
                        title: "Module Record Viewer",
                    },
                },
                {
                    path: "/module/:moduleName",
                    name: "module-viewer",
                    component: () => import("./views/Pages/Module/ModuleViewer.vue"),
                    meta: {
                        title: "Module Viewer",
                    },
                },
                {
                    path: `automations`,
                    name: `automations`,
                    component: () => import("./views/Pages/Automation/Automation.vue"),
                    meta: {
                        title: `Automations`,
                        permission: "automation.get",
                        //permission: "chatbot.stories.view", //todo implement permission
                    },
                },
                ...Object.values(AutomationMenuItems()).map(({ key, label }) => ({
                    path: `automations/${key}`,
                    name: `automations-${key}`,
                    component: () => import("./views/Pages/Automation/Automation.vue"),
                    meta: {
                        title: `Automation - ${label}`,
                        permission: "automation.get",
                    },
                })),
                {
                    path: "/automations/:id/design/block*",
                    name: "automation-design-block",
                    component: () => import("./views/Pages/Automation/pages/dashboard/AutomationPlannerPage.vue"),
                    meta: {
                        title: "Automation",
                        permission: "automation.get",
                        // permission: "chatbot.stories.view",//todo implement permission
                    },
                },
                {
                    path: "/automations/:id/design/flow*",
                    name: "automation-design-flow",
                    component: () => import("./views/Pages/Automation/pages/dashboard/AutomationPlannerPage.vue"),
                    meta: {
                        title: "Automation",
                        permission: "automation.get",
                        // permission: "chatbot.stories.view",//todo implement permission
                    },
                },
                {
                    path: "/automations/:id/design",
                    name: "automation-design",
                    component: () => import("./views/Pages/Automation/pages/dashboard/AutomationPlannerPage.vue"),
                    meta: {
                        title: "Automation",
                        permission: ["automation.get", "automation.update"],
                        // permission: "chatbot.stories.view",//todo implement permission
                    },
                },
                {
                    path: "/cache-manager",
                    name: "cache-manager",
                    component: () => import("./views/Pages/Cache/CacheManager.vue"),
                    meta: {
                        title: "Cache Manager",
                        permission: "automation.view",
                    },
                },

                ...Object.values(ChatbotMenuItems()).map(({ key, label }) => ({
                    path: `chatbot/${key}`,
                    name: `chatbot-${key}`,
                    component: () => import("./views/Pages/Chatbot/Chatbot.vue"),
                    meta: {
                        title: `Chatbot - ${label}`,
                    },
                })),
                {
                    path: `chatbot`,
                    name: `chatbot`,
                    component: () => import("./views/Pages/Chatbot/Chatbot.vue"),
                    meta: {
                        title: `Chatbot`,
                        permission: "chatbot.stories.view",
                    },
                },
                {
                    path: "/chatbot/block-market/editor/new",
                    name: "block-market-create",
                    component: () => import("./views/Pages/Chatbot/pages/blockMarket/BlockEditorPage.vue"),
                    meta: {
                        title: "Create Custom Block",
                        permission: "chatbot.blocks.create",
                    },
                },
                {
                    path: "/chatbot/block-market/editor/:id",
                    name: "block-market-edit",
                    component: () => import("./views/Pages/Chatbot/pages/blockMarket/BlockEditorPage.vue"),
                    meta: {
                        title: "Edit Custom Block",
                        permission: "chatbot.blocks.update",
                    },
                },
                {
                    path: "/chatbot/story/:id/:version/block*",
                    name: "chatbot-story-block",
                    component: () => import("./views/Pages/Chatbot/pages/dashboard/ChatbotPage.vue"),
                    meta: {
                        title: "ChatBot",
                        permission: "chatbot.stories.view",
                    },
                },
                {
                    path: "/chatbot/story/:id/:version/flow*",
                    name: "chatbot-story-flow",
                    component: () => import("./views/Pages/Chatbot/pages/dashboard/ChatbotPage.vue"),
                    meta: {
                        title: "ChatBot",
                        permission: "chatbot.stories.view",
                    },
                },
                {
                    path: "/chatbot/story/:id/:version*",
                    name: "chatbot-story-version",
                    component: () => import("./views/Pages/Chatbot/pages/dashboard/ChatbotPage.vue"),
                    meta: {
                        title: "ChatBot",
                        permission: "chatbot.stories.view",
                    },
                },
                {
                    path: "/chatbot/reports/paid-chats",
                    name: "chatbot-reports-paid",
                    component: () => import("./views/Pages/Chatbot/pages/reports/PaidChats"),
                    meta: {
                        title: "Chatbot Paid Chats",
                        permission: "chatbot.reports.view",
                    },
                },
                {
                    path: "/chatbot/reports/all-messages",
                    name: "chatbot-templates-all-msg",
                    component: () => import("./views/Pages/Chatbot/pages/reports/AllMessages"),
                    meta: {
                        title: "ChatbotTemplates",
                        permission: "chatbot.reports.view",
                    },
                },
                {
                    path: "/chatbot/reports/avarage-messages",
                    name: "chatbot-templates-avarage",
                    component: () => import("./views/Pages/Chatbot/pages/reports/AvarageMessages"),
                    meta: {
                        title: "ChatbotTemplates",
                        permission: "chatbot.reports.view",
                    },
                },
                {
                    path: "/chatbot/reports/all-users",
                    name: "chatbot-templates-all-user",
                    component: () => import("./views/Pages/Chatbot/pages/reports/AllUsers"),
                    meta: {
                        title: "ChatbotTemplates",
                        permission: "chatbot.reports.view",
                    },
                },
                {
                    path: "ticket",
                    name: "ticket",
                    component: () => import("./views/Pages/Ticket/Ticket.vue"),
                    meta: {
                        title: "Ticket",
                        permission: ["offlineSupportRequest.get", "ticket"],
                    },
                },
                {
                    path: "drive",
                    name: "drive",
                    component: () => import("./views/Pages/Drive/DriveHome.vue"),
                    meta: {
                        title: "Drive",
                        shouldSelectAllow: true,
                        permission: ["drive.get"],
                    },
                },
                {
                    path: "/drive/:id",
                    name: "Drive Detail",
                    component: () => import("./views/Pages/Drive/DriveHome.vue"),
                    meta: {
                        title: "Drive Detail",
                        isAdmin: false,
                    },
                },
                {
                    path: "archives/:visitorId",
                    name: "archives",
                    component: () => import("./views/Pages/Archives/Archives.vue"),
                    meta: {
                        title: "Arşiv",
                        permission: "archives.get",
                    },
                },
                {
                    path: "archives",
                    name: "archives",
                    component: () => import("./views/Pages/Archives/Archives.vue"),
                    meta: {
                        title: "Arşiv",
                        permission: "archives.get",
                    },
                },
                {
                    path: "supsis-app",
                    name: "apps",
                    component: () => import("./views/Pages/Apps"),
                    meta: {
                        title: "Uygulamalar",
                        permission: "",
                    },
                },
                {
                    path: "integrations",
                    name: "integrations",
                    component: () => import("./views/Pages/Integrations"),
                    meta: {
                        title: "Entegrasyonlar",
                        permission: "integrations.view",
                        shouldSelectAllow: true,
                    },
                },
                {
                    path: "/integrations/webtabs",
                    name: "webtabs-list",
                    component: () => import("./views/Pages/WebTabs/WebTabsList.vue"),
                    meta: {
                        title: "Web Sekmeler",
                        permission: "integrations.view",
                    },
                },
                {
                    path: "/integrations/webtabs/new",
                    name: "webtabs-create",
                    component: () => import("./views/Pages/WebTabs/WebTabDetail.vue"),
                    meta: {
                        title: "Yeni Web Sekmesi",
                        permission: "integrations.create",
                    },
                },
                {
                    path: "/integrations/webtabs/:id/edit",
                    name: "webtabs-edit",
                    component: () => import("./views/Pages/WebTabs/WebTabDetail.vue"),
                    meta: {
                        title: "Web Sekmesi Düzenle",
                        permission: "integrations.update",
                    },
                },
                {
                    path: "/webtab/:id",
                    name: "webtab-viewer",
                    component: () => import("./views/Pages/WebTabs/WebTabViewer.vue"),
                    meta: {
                        title: "Web Sekmesi",
                    },
                },
                {
                    path: "/integrations/webapps",
                    name: "webapps-list",
                    component: () => import("./views/Pages/WebApps/WebAppsList.vue"),
                    meta: {
                        title: "Web Apps",
                        permission: "integrations.view",
                    },
                },
                {
                    path: "/integrations/webapps/new",
                    name: "webapps-create",
                    component: () => import("./views/Pages/WebApps/WebAppDetail.vue"),
                    meta: {
                        title: "Yeni Web App",
                        permission: "integrations.create",
                    },
                },
                {
                    path: "/integrations/webapps/:id/edit",
                    name: "webapps-edit",
                    component: () => import("./views/Pages/WebApps/WebAppDetail.vue"),
                    meta: {
                        title: "Web App Düzenle",
                        permission: "integrations.update",
                    },
                },
                {
                    path: "mails",
                    name: "mails",
                    component: () => import("./views/Pages/Mail/Mail"),
                    meta: {
                        title: "Mailler",
                        permission: "",
                    },
                },
                {
                    path: "/mails/inbox",
                    name: "mail-inbox",
                    component: () => import("./views/Pages/Mail/Mail"),
                    meta: {
                        title: "Mailler",
                        permission: "",
                    },
                },
                {
                    path: "/mails/templates",
                    name: "mails-templates",
                    component: () => import("./views/Pages/Mail/Mail"),
                    meta: {
                        title: "Mail Templates",
                        permission: "",
                    },
                },
                {
                    path: "/mails/broadcast",
                    name: "mails-broadcast",
                    component: () => import("./views/Pages/Mail/Mail"),
                    meta: {
                        title: "Mail Broadcast",
                        permission: "",
                    },
                },
                {
                    path: "/mails/customer-groups",
                    name: "mails-customer-groups",
                    component: () => import("./views/Pages/Mail/Mail"),
                    meta: {
                        title: "Mail Customer Groups",
                        permission: "",
                    },
                },
                {
                    path: "/mails/new",
                    name: "mails-new",
                    component: () => import("./views/Pages/Mail/Mail"),
                    meta: {
                        title: "New Mail Interface",
                        permission: "",
                    },
                },
                {
                    path: "/tasks",
                    name: "tasks",
                    component: () => import("./views/Pages/Tasks/Home.vue"),
                },
                {
                    path: "/tasks/workflow/:id/detail",
                    name: "task-workflow-detail",
                    component: () => import("./components/task/EditWorkFlow.vue"),
                    meta: {
                        title: "Workflow Detail",
                    },
                },
                {
                    path: "form",
                    name: "form",
                    component: () => import("./views/Pages/Forms/Home.vue"),
                    meta: {
                        title: "Forms",
                        permission: "form.get",
                    },
                    beforeEnter: (to, from, next) => {
                        const { query } = to;
                        if (!query.type) {
                            next({ name: "form", query: { ...query, type: "form" } });
                        } else {
                            next();
                        }
                    },
                },
                {
                    path: "form/build/:formId",
                    name: "buildForm",
                    component: () => import("./views/Pages/Forms/Home.vue"),
                    props: true,
                    meta: {
                        title: "Form Builder",
                        permission: ["form.create", "form.get", "form.update"],
                    },
                },
                {
                    path: "form/inbox/:formId",
                    name: "formInbox",
                    component: () => import("./views/Pages/Forms/Components/FormInbox.vue"),
                    meta: {
                        title: "Form Inbox",
                        permission: ["form.get"],
                    },
                },
                {
                    path: "reservation/landing-page",
                    name: "ReservationLandingPage",
                    component: () =>
                        import(
                            "./views/Pages/Calendar/Component/reservation-landing-page/ReservationLandingPageBuilder.vue"
                        ),
                    meta: {
                        title: "Reservation Landing Page ",
                        permission: "",
                    },
                },
                {
                    path: "reservation/programs",
                    name: "reservation-programs",
                    component: ReservationPrograms,
                    meta: {
                        title: "Rezervasyon Programları",
                        permission: "",
                    },
                },
                {
                    path: "reservation",
                    name: "Reservation",
                    component: () => import("./views/Pages/Calendar/Component/Reservation.vue"),
                    meta: {
                        title: "Takvim",
                        permission: "",
                    },
                },
                {
                    path: "reservation/automations",
                    name: "calendar-automations",
                    component: () => import("./views/Pages/Calendar/Calendar.vue"),
                    props: {
                        defaultPage: "automations",
                    },
                    meta: {
                        title: "Automations",
                        permission: "",
                    },
                },
                {
                    path: "reservation/:id",
                    name: "Reservation",
                    component: () => import("./views/Pages/Calendar/Component/Reservation.vue"),
                    meta: {
                        title: "Takvim",
                        permission: "",
                    },
                },
                {
                    path: "calendar/events",
                    name: "calendar-events",
                    component: CalendarEvents,
                    props: { type: "calendar", showSideMenu: true },
                    meta: {
                        title: "Etkinlikler",
                        permission: "",
                    },
                },
                {
                    path: "calendar/reservations",
                    name: "calendar-reservations",
                    component: CalendarEvents,
                    props: { type: "reservation", showSideMenu: true },
                    meta: {
                        title: "Rezervasyonlar",
                        permission: "",
                    },
                },

                {
                    path: "calendar/:type/:date",
                    name: "calendar",
                    component: () => import("./views/Pages/Calendar/Calendar.vue"),
                    meta: {
                        title: "Takvim",
                        permission: "",
                    },
                },
                {
                    path: "calendar/:type/:date/:eventId",
                    name: "calendar",
                    component: () => import("./views/Pages/Calendar/Calendar.vue"),
                    meta: {
                        title: "Takvim",
                        permission: "",
                    },
                },
                {
                    path: "calendar/:type",
                    name: "calendar",
                    component: () => import("./views/Pages/Calendar/Calendar.vue"),
                    meta: {
                        title: "Takvim",
                        permission: "",
                    },
                },
                {
                    path: "calendar",
                    name: "calendar",
                    component: () => import("./views/Pages/Calendar/Calendar.vue"),
                    meta: {
                        title: "Takvim",
                        permission: "",
                    },
                },
                {
                    path: "visitors",
                    name: "visitors",
                    component: () => import("./views/Pages/Visitors/List"),
                    meta: {
                        title: "Ziyaretçiler",
                        permission: "visitor.list.view",
                    },
                },
                {
                    path: "visitors/:visitorId",
                    name: "visitor-detail",
                    component: () => import("./views/Pages/VisitorDetail"),
                    meta: {
                        title: "Ziyaretçiler",
                        permission: ["visitor.update", "visitor.delete", "visitor.block", "visitor.unblock"],
                    },
                    props: (route) => ({
                        visitorId: route.params.visitorId,
                    }),
                },
                {
                    path: "teamChat",
                    name: "teamChat",
                    component: () => import("./views/Pages/TeamChat/TeamChat"),
                    props: {
                        kioskMode: true,
                    },
                    meta: {
                        title: "Takım Konuşması",
                        permission: "",
                    },
                },
                {
                    path: "/integrations/webhook",
                    name: "integrations-webhook",
                    component: () => import("./views/Pages/Integrations/Webhooks/WebhookList.vue"),
                    meta: {
                        title: "ChatBot",
                        //permission: "chatbot",
                        permission: "integrations.view",
                    },
                },
                {
                    path: "/integrations/webhook/new",
                    name: "integrations-webhook-new",
                    component: () => import("./views/Pages/Integrations/Webhooks/WebHookForm"),
                    meta: {
                        title: "ChatBot",
                        //permission: "chatbot",
                        permission: "integrations.create",
                    },
                },
                {
                    path: "/integrations/webhook/:id/update",
                    name: "integrations-webhook-update",
                    component: () => import("./views/Pages/Integrations/Webhooks/WebHookForm"),
                    meta: {
                        title: "ChatBot",
                        //permission: "chatbot",
                        permission: "integrations.create",
                    },
                },
                {
                    path: "/me/notification-settings",
                    name: "my-notification-settings",
                    component: () => import("./views/Pages/Settings/pages/notification-settings/NotificationSettings"),
                    meta: {
                        title: "My Notification Settings",
                    },
                },
                {
                    path: "/profile",
                    name: "profile",
                    component: () => import("./views/Pages/Profile/Profile.vue"),
                    meta: {
                        title: "Profile",
                    },
                },

                ...Object.values(SettingsMenuTypes(this)).map(({ key, label, isPublic, routeMeta = {} }) => ({
                    path: `settings/${key}`,
                    name: `settings-${key}`,
                    component: () => import("./views/Pages/Settings/Settings"),
                    meta: {
                        ...routeMeta,
                        title: `Settings - ${label}`,
                        permission: isPublic ? "" : "setting.get",
                    },
                })),
                {
                    path: "settings",
                    name: "settings-v2",
                    component: () => import("./views/Pages/Settings/Settings"),
                    meta: {
                        title: "Settings",
                    },
                },
                {
                    path: "report-new",
                    name: "report-new",
                    component: () => import("./views/Reports/Reports.vue"),
                },
                {
                    path: "activities",
                    name: "activities",
                    component: () => import("./views/Pages/Activity/Activities.vue"),
                    meta: {
                        title: "Activities",
                        permission: "",
                        suspendAllow: false,
                    },
                },
                {
                    path: "notifications",
                    name: "notifications",
                    component: () => import("./views/Pages/Notification/NotificationsPage.vue"),
                    meta: {
                        title: "Notifications",
                        permission: "",
                        suspendAllow: false,
                    },
                },
                {
                    path: "admin-users",
                    name: "adminUsers",
                    component: () => import("./views/AdminPages/AdminUsers.vue"),
                    meta: {
                        title: "Admin Kullanıcılar",
                        isAdmin: true,
                    },
                },
                {
                    path: "/sites/:siteAddress",
                    name: "site-details",
                    component: () => import("./views/AdminPages/SiteDetail.vue"),
                    meta: {
                        title: "Site Detail",
                        isAdmin: true,
                    },
                },
                {
                    path: "sites",
                    name: "sites",
                    component: () => import("./views/AdminPages/Sites/Sites.vue"),
                    meta: {
                        title: "Siteler",
                        isAdmin: true,
                    },
                },
                {
                    path: "sites-new",
                    name: "sites-new",
                    component: () => import("./views/AdminPages/Sites/SiteList.vue"),
                    meta: {
                        title: "Siteler",
                        isAdmin: true,
                    },
                },
                {
                    path: "cluster-dashboard",
                    name: "cluster-dashboard",
                    component: () => import("./views/AdminPages/ClusterDashboard.vue"),
                    meta: {
                        title: "Cluster Dashboard",
                        isAdmin: true,
                    },
                },
                {
                    path: "admin-reports",
                    name: "admin-reports",
                    component: () => import("./views/AdminReports/Reports.vue"),
                    meta: {
                        title: "Admin Reports",
                        isAdmin: true,
                    },
                },
                {
                    path: "invoices",
                    name: "invoices",
                    component: () => import("./views/Pages/Invoices"),
                    meta: {
                        title: "Invoices",
                        isAdmin: true,
                    },
                },
                {
                    path: "global-settings",
                    name: "globalSettings",
                    component: () => import("./views/Pages/GlobalSettings"),
                    meta: {
                        title: "Ayarlar",
                        isAdmin: true,
                    },
                },
                {
                    path: "ErrorReports",
                    name: "ErrorReports",
                    component: () => import("./views/AdminPages/ErrorReports.vue"),
                    meta: {
                        title: "ErrorReport",
                        isAdmin: true,
                    },
                },
                {
                    path: "/install-code",
                    name: "InstallCode",
                    component: () => import("./views/Pages/InstallationInstarctionPage"),
                    meta: {
                        title: "Installation",
                        isAdmin: false,
                        requiresAuth: false,
                        permission: "chat.get",
                    },
                },
                {
                    path: "/triggers",
                    name: "Triggers",
                    component: () => import("./views/Pages/Integrations/WebChat/pages/Triggers.vue"),
                    meta: {
                        title: "Triggers",
                        isAdmin: false,
                        requiresAuth: false,
                        permission: "trigers.view",
                    },
                },
                {
                    path: "/announcements",
                    name: "Announcements",
                    component: () => import("./views/AdminPages/Announcements.vue"),
                    meta: {
                        title: "Duyurular",
                        isAdmin: true,
                    },
                },
                {
                    path: "/coupons",
                    name: "Kuponlar",
                    component: () => import("./views/Pages/Coupons/Coupons.vue"),
                    meta: {
                        title: "Kuponlar",
                        isAdmin: true,
                    },
                },
                {
                    path: "/billing/plans/:type",
                    name: "BillingPlans",
                    component: () => import("./views/Pages/Billing/Plans.vue"),
                    meta: {
                        title: "Fatura Planlar",
                        isAdmin: false,
                        shouldSelectAllow: true,
                        suspendAllow: true,
                    },
                },
                {
                    path: "/billing/invoice/:id/",
                    name: "InvoiceDetail",
                    component: () => import("./views/Pages/Billing/InvoiceDetail.vue"),
                    meta: {
                        title: "Fatura Detay",
                        isAdmin: false,
                        shouldSelectAllow: true,
                        suspendAllow: true,
                    },
                },
                {
                    path: "/tables/t/:id/permissions",
                    name: "Table Permissions",
                    component: () => import("./views/Pages/Tables/TablePermissionsPage.vue"),
                    meta: {
                        title: "Table Permissions",
                        isAdmin: false,
                        permission: ["table.get"],
                    },
                },
                {
                    path: "/tables/t/:id",
                    name: "Table Detail",
                    component: () => import("./views/Pages/Tables/detail/TableDetail.vue"),
                    meta: {
                        title: "Tables",
                        isAdmin: false,
                        permission: ["table.get"],
                    },
                },
                {
                    path: "/tables",
                    name: "Tables",
                    component: () => import("./views/Pages/Tables/TablesHome.vue"),
                    meta: {
                        title: "Tables",
                        isAdmin: false,
                        permission: ["table.get"],
                    },
                },
                // {
                //     path: "/tasks/:taskId",
                //     name: "task-detail",
                //     component: () => import("./views/Pages/Tasks/TaskDetail.vue"),
                //     meta: {
                //         title: "Görev Detayı",
                //         permission: "task.view",
                //     },
                // },
                {
                    path: "/whatsapp-start-chat-zoho",
                    name: "whatsapp-start-chat-zoho",
                    component: () => import("./views/Pages/Integrations/meta-leads/WhatsappChatStarterWithZoho.vue"),
                    meta: {
                        title: "Whatsapp Chat Starter - Zoho",
                        isAdmin: false,
                    },
                },
                {
                    path: "/whatsapp-start-chat",
                    name: "whatsapp-start-chat",
                    component: () => import("./views/Pages/Integrations/meta-leads/WhatsappChatStarter.vue"),
                    meta: {
                        title: "Whatsapp Chat Starter",
                        isAdmin: false,
                    },
                    props: (route) => ({
                        fullscreenMode: true,
                    }),
                },
                {
                    path: "/settings/roles/:id/edit",
                    name: "roles-edit",
                    component: () => import("./views/Pages/Settings/Settings.vue"),
                    props: (route) => ({
                        tab: "roles",
                        initialIsRoleEdit: true,
                        initialRoleId: route.params.id,
                    }),
                    meta: {
                        title: "Rol Düzenle",
                        permission: "role.update",
                    },
                },
                {
                    path: "/integrations/voice-agent/:id/dashboard",
                    name: "voice-agent-dashboard",
                    component: () => import("./views/Pages/Integrations/voice-agent/VoiceAgentDashboard.vue"),
                    props: true,
                    meta: {
                        title: "AI Ses Ajanı Dashboard",
                    },
                    redirect: (to) => {
                        const tab = to.query.tab || "agents";
                        return `/integrations/voice-agent/${to.params.id}/dashboard/${tab}`;
                    },
                },
                ...Object.values(VoiceAgentMenuTypes()).map(({ key, label }) => ({
                    path: `/integrations/voice-agent/:id/dashboard/${key}`,
                    name: `voice-agent-dashboard-${key}`,
                    component: () => import("./views/Pages/Integrations/voice-agent/VoiceAgentDashboard.vue"),
                    props: (route) => ({
                        channelId: route.params.id,
                        tab: key,
                    }),
                    meta: {
                        title: `AI Ses Ajanı - ${label}`,
                        params: { tab: key },
                    },
                })),
            ],
        },
        {
            path: "404",
            name: "not-found",
            component: () => import("./views/Pages/NotFound404.vue"),
            meta: {
                title: "404 - Sayfa Bulunamadı",
            },
        },
        {
            path: "*",
            name: "not-found",
            component: () => import("./views/Pages/NotFound404.vue"),
            meta: {
                title: "404 - Sayfa Bulunamadı",
            },
        },
    ],
});

router.beforeEach((to, from, next) => {
    try {
        const isLoggedIn = store.getters["auth/isLoggedIn"],
            authRequired = to.matched.some((record) => _.get(record, "meta.requiresAuth", false)),
            isRoot = store.getters["auth/isRoot"],
            isBlockedConnection = store.state.app.blockedConnection,
            permission = _.get(to, "meta.permission", null),
            userPermissions = _.get(store.state.auth.user, "role.permissions", []);

        console.log(`[ROUTER] before`, {
            isLoggedIn,
            authRequired,
            isRoot,
            permission,
            userPermissions,
        });

        if (isBlockedConnection && to.name !== "blocked") {
            return next({ name: "blocked" });
        }

        if (!isLoggedIn && authRequired) {
            console.log(`[ROUTER] redirect to login`);
            return next({ name: "login", query: { redirect: to.fullPath } });
        }

        if (Array.isArray(permission)) {
            const hasAnyPermission = permission.some((perm) => userPermissions.find((p) => p.name === perm));
            if (!hasAnyPermission && !isRoot) {
                console.log(`[ROUTER] permission error 1`);
                return next({ name: "permission" });
            }
        } else {
            if (!!permission && !isRoot && userPermissions.find((p) => p.name !== permission)) {
                console.log(`[ROUTER] permission error 2`);
                return next({ name: "permission" });
            }
        }

        // Doğruluğu sağlama amaçlı eklenmiştir.
        const minAcceptedMountedDate = 15 * 1000;
        const appMountedDate = store.state.app.appMountedDate;
        const isAppMounted = appMountedDate && appMountedDate < Date.now() - minAcceptedMountedDate;
        if (
            store.state.setting.initialized &&
            store.state.site.initializedFeatures &&
            store.state.site.plansAvailable &&
            store.getters["setting/shouldSelectPlan"].enabled &&
            !!store.state.auth.token &&
            !store.state.auth.adminUser &&
            !store.getters["app/trialInfo"].trial &&
            !_.get(to, "meta.shouldSelectAllow", false) &&
            isAppMounted
        ) {
            console.log(`[ROUTER] select plan`);
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.SHOULD_SELECT_PLAN);
            return next({ name: "settings-billing" });
        }

        console.log(`[ROUTER] next`);
        return next();
    } catch (e) {
        console.error("[ROUTER] beforeEach error", e);
        next();
    }
});

export default router;
